import { Component } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import {
  BaseCssProperties,
  BaseWidgetProperties,
  ProviderClass,
  baseCssConfigStyle,
  buttonNestedWidgetConfigStyles,
  commonContentStyleList,
  commonTextContentStyleList,
} from '@finxone-platform/shared/sys-config-types';
import { BaseComponent } from '../base/base.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-otp-verification-widget',
  templateUrl: './otp-verification-widget.component.html',
  styleUrl: './otp-verification-widget.component.scss',
})
export class OtpVerificationWidgetComponent extends BaseComponent {
  public textContentStyle: baseCssConfigStyle;
  public inputStyle: baseCssConfigStyle;
  public inputInactiveStyle: baseCssConfigStyle;
  public widgetConfig: BaseWidgetProperties;
  public inputBaseStyle: baseCssConfigStyle;
  public colorStyle: baseCssConfigStyle;
  public verifyButtonStyle: baseCssConfigStyle;
  public buttonContent: string;
  public resendButtonStyle: baseCssConfigStyle;
  public timerTextStyle: baseCssConfigStyle;
  public resendButtonContent: string;
  public timerTextContent: string;
  public fieldType: 'email' | 'phone';
  public buttonGlobalStyles = {
    verifyButton: {
      globalStylingClass: '',
      isAllowedGlobalStyling: false,
    },
    resendButton: {
      globalStylingClass: '',
      isAllowedGlobalStyling: false,
    },
  };

  constructor(private configService: ConfigService, public dataIn: ProviderClass<any>) {
    super();
    if (this.dataIn?.attri) {
      this.widgetConfig = this.dataIn.attri.widgetProperties;
      this.buttonContent =
        this.dataIn.widgetConfig?.nestedWidgets?.['verifyButton'].widgetProperties.textContent ?? 'Verify';
      this.resendButtonContent =
        this.dataIn.widgetConfig?.nestedWidgets?.['resendButton'].widgetProperties.textContent ?? 'Resend';

      this.timerTextContent =
        this.dataIn.widgetConfig?.nestedWidgets?.['timerContent']?.widgetProperties?.textContent ?? '';
    }
    this.getWidgetCssConfig();
    this.getGlobalStyling();
  }

  private getGlobalStyling() {
    if (
      this.dataIn.widgetConfig.nestedWidgets?.['verifyButton'].widgetProperties?.['globalStylingClass'] &&
      this.dataIn.widgetConfig.nestedWidgets?.['verifyButton'].widgetProperties?.['globalStyling']
    ) {
      this.buttonGlobalStyles.verifyButton.globalStylingClass =
        this.dataIn.widgetConfig.nestedWidgets?.['verifyButton'].widgetProperties?.['globalStylingClass'] ??
        '';
      this.buttonGlobalStyles.verifyButton.isAllowedGlobalStyling =
        this.dataIn.widgetConfig.nestedWidgets?.['verifyButton'].widgetProperties?.['globalStyling'] ?? false;
    }
    if (
      this.dataIn.widgetConfig.nestedWidgets?.['resendButton'].widgetProperties?.['globalStylingClass'] &&
      this.dataIn.widgetConfig.nestedWidgets?.['resendButton'].widgetProperties?.['globalStyling']
    ) {
      this.buttonGlobalStyles.resendButton.globalStylingClass =
        this.dataIn.widgetConfig.nestedWidgets?.['resendButton'].widgetProperties?.['globalStylingClass'] ??
        '';
      this.buttonGlobalStyles.resendButton.isAllowedGlobalStyling =
        this.dataIn.widgetConfig.nestedWidgets?.['resendButton'].widgetProperties?.['globalStyling'] ?? false;
    }
  }

  private getWidgetCssConfig() {
    this.contentStyle = this.configService.getSpecificBaseCssStyle(
      this.dataIn?.attri,
      commonContentStyleList,
    );
    this.colorStyle = this.configService.getSpecificBaseCssStyle(this.dataIn?.attri, [
      BaseCssProperties.COLOR,
    ]);

    this.textContentStyle = this.configService.getSpecificBaseCssStyle(
      this.dataIn?.attri,
      commonTextContentStyleList,
    );
    const inputFontSize = this.configService.getSpecificBaseCssStyle(this.dataIn?.attri, [
      BaseCssProperties.TEXT_INPUT_FONT_SIZE,
    ]);

    const { baseStyle, activeStyle, inactiveStyle } = this.configService.getInputFieldCssStyles(
      this.widgetConfig,
    );

    this.inputStyle = baseStyle;
    this.inputBaseStyle = { ...activeStyle, ...inputFontSize };
    this.inputInactiveStyle = { ...inactiveStyle, ...inputFontSize };

    this.verifyButtonStyle = this.configService.getSpecificBaseCssStyle(
      this.getNestedWidgetConfig(this.dataIn, 'verifyButton'),
      buttonNestedWidgetConfigStyles,
    );

    this.resendButtonStyle = this.configService.getSpecificBaseCssStyle(
      this.getNestedWidgetConfig(this.dataIn, 'resendButton'),
      buttonNestedWidgetConfigStyles,
    );

    this.timerTextStyle = this.configService.getSpecificBaseCssStyle(
      this.getNestedWidgetConfig(this.dataIn, 'timerContent'),
      buttonNestedWidgetConfigStyles,
    );

    this.fieldType = this.widgetConfig.widgetContext.type;
  }
}
